import { render, staticRenderFns } from "./ConvoStatements.vue?vue&type=template&id=73493872&"
import script from "./ConvoStatements.vue?vue&type=script&lang=js&"
export * from "./ConvoStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports